export enum CreateUserSource {
    ASSESSMENT = 'ASSESSMENT',
    PLATFORM_INVITE = 'PLATFORM_INVITE',
    SUPPLIER_REGISTRATION = 'SUPPLIER_REGISTRATION',
}